import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { MediaContext } from '..';
import { useSelector } from 'react-redux';

const CustomTempGetMyFolderQuery = (debounceSearchTerm) =>
{
	const { mediaState } = useContext(MediaContext);
	const userData = useSelector((state) => state.mysession.session);

	const folderId = useParams()?.id || '';
	const clickedUser = useParams()?.userId || '';
	const query = {
		uid     : userData?.userId,
		comid   : userData?.companyId,
		empRole : userData?.empRole,
		role    : userData?.role,
		limit   : 12,
		skip    : mediaState?.page
	};

	if ([ 1, -1 ].includes(mediaState?.sort)) query.sortByName = mediaState.sort;

	if (folderId !== '')
	{
		query.id = folderId;
	}
	if (clickedUser !== '')
	{
		query.userId = clickedUser;
	}

	if (debounceSearchTerm !== '')
	{
		query.search = debounceSearchTerm;
	}

	return query;
};

export default CustomTempGetMyFolderQuery;
